import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import Tooltip from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';

type Props = {
    className?: string;
    iconSize?: 'small' | 'large';
};

const TopBadge = ({ className = '', iconSize = 'large' }: Props) => {
    return (
        <Tooltip
            header={<FormattedMessage id="top_rated_header" />}
            placement="bottom"
            trigger={
                <StyledTopRatedTrigger className={className}>
                    <StyledImage
                        $small={iconSize === 'small'}
                        alt="badge"
                        height={iconSize === 'small' ? 18 : 24}
                        src="https://p1.liveauctioneers.com/dist/images/badge.svg"
                        width={iconSize === 'small' ? 18 : 25}
                    />{' '}
                    <span>
                        <FormattedMessage id="top" />
                    </span>
                </StyledTopRatedTrigger>
            }
        >
            <div>
                <TipWrapper secondary>
                    <FormattedMessage id="top_message" />
                </TipWrapper>
            </div>
        </Tooltip>
    );
};

export default React.memo<Props>(TopBadge);

const TipWrapper = styled(Text)`
    display: flex;
    white-space: pre-wrap;
    flex-direction: column;
    text-transform: none;
`;

const StyledImage = styled.img<{ $small: boolean }>`
    height: ${({ $small }) => ($small ? 18 : 24)}px;
    margin-right: 4px;
`;

const StyledTopRatedTrigger = styled.span`
    && {
        width: 106px;
        font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
        font-size: 12px;
        color: ${({ theme }) => theme.colors.orange100};
        vertical-align: middle;
        display: inline-flex;
        justify-content: space-evenly;
        align-items: center;
    }
`;
